import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwelve-courses',
  templateUrl: './hometwelve-courses.component.html',
  styleUrls: ['./hometwelve-courses.component.scss']
})
export class HometwelveCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
